import DataTable from './DataTable'
import PopupBase from './PopupBase'
import StatusControls from './StatusControls'

export default {
  DataTable,
  PopupBase,
  StatusControls
}
